define(["wcs.find-in-store-model", "pubsub"],
function(findInStoreModel) {
	
	var AttributeEntry, ValueEntry;
	var DEBUG = false;
	
	var ProductAvailability = function ( formIndex ) {

		if ( DEBUG ) console.log('ProductAvailability Constructor');

		if (!(this instanceof ProductAvailability)) {
			return new ProductAvailability();
		}

		this.attributes = {};
		this.availableItems = {};
		this.selections = {};
		this.subscribers = [];
		this.partNumbers = {};
		this.parentProductFormIndex = formIndex;

		return this;

	};

	AttributeEntry = function (parent, name) {

		this.parent = parent;
		this.name = name;
		this.values = {};

	};

	AttributeEntry.prototype = {

		name: null,
		values: {},

		onChange: function (value, availability, defaultSelected, isHidden) {

			this.parent.fireChange(this.name, value, availability, defaultSelected, isHidden);

		}

	};

	ValueEntry = function (parent, value) {

		this.parent = parent;
		this.value = value;
		this.items = {};

	};

	ValueEntry.prototype = {

		available: null,
		defaultSelected: null,
		isHidden: null,

		setAvailable: function (available) {

			var changed = this.available !== available;

			this.available = available;

			if (changed) {
				this.parent.onChange(this.value, available, this.defaultSelected, this.isHidden);
			}

		},

		setDefault: function(available, defaultSelected, isHidden) {
			this.parent.onChange(this.value, available, defaultSelected, isHidden);
		}

	};
	
	ProductAvailability.prototype = {
	
		addAvailableItem: function (item, qty) {
	
			this.availableItems[item] = qty;
	
		},
	
		addAttributeValue: function (attribute, value) {
	
			this.addItemAttributeValue(null, attribute, value);
	
		},
	
		addItemAttributeValue: function (item, attribute, value) {
	
			var attributeEntry, valueEntry;
	
			attributeEntry = this.attributes[attribute];
	
			if (!attributeEntry) {
				attributeEntry = new AttributeEntry(this, attribute);
				this.attributes[attribute] = attributeEntry;
			}
	
			valueEntry = attributeEntry.values[value];
	
			if (!valueEntry) {
				valueEntry = new ValueEntry(attributeEntry, value);
				attributeEntry.values[value] = valueEntry;
			}
	
			if (item) {
				valueEntry.items[item] = item;
			}
	
		},
	
		addItemPartNumber: function (item, partNumber) {
	
			this.partNumbers[item] = partNumber;
	
		},
	
		onChange: function (context, fn) {
	
			if (typeof context === 'function') {
				fn = context;
				context = this;
			}
			this.subscribers.push({
				context: context,
				fn: fn
			});
	
		},
	
		fireChange: function (attribute, value, available, defaultSelected, isHidden) {
			
			var self = this, 
				i, subscriber;
			
			Object.keys(self.subscribers).forEach(function(item, index){
				subscriber = self.subscribers[index];
				subscriber.fn.apply(subscriber.context, [attribute, value, available, defaultSelected, isHidden]);
			});
	
		},
	
		isAvailable: function (attribute, value) {
	
			var attributeEntry, valueEntry;
	
			attributeEntry = this.attributes[attribute];
	
			if (!attributeEntry) {
				return false;
			}
	
			valueEntry = attributeEntry.values[value];
	
			if (!valueEntry) {
				return false;
			}
	
			return valueEntry.available === true;
	
		},
	
		select: function (attribute, value) {
			if(typeof value === "undefined"){
				return;
			}
	
			this.selections[attribute] = value;
	
		},
		/**
		 *  Resolves available items based on the given selections.
		 *  @param {Object} [selections] A map of the selections where  selection is an association of attribute to value.
		 *  @param {Boolean} [checkQty] A flag to specify whether to consider items with qty == 0, as unavailable.
		 *  @returns {Object} A set containing the resolved items.
		 */
		resolveItems: function (selections, checkQty) {
			var self = this,
				availableItems, attribute, attributeEntry, valueEntry, intersectingItems, item;
			
			if (!selections) {			
				selections = this.selections;
			}

			availableItems = this.availableItems;
			findInStoreModel.setProductSelection(selections);

			Object.keys(selections).map(function(attribute){
				
				if( !(attribute in self.attributes ) ){
					return false;
				}
				
				attributeEntry = self.attributes[attribute];
				valueEntry = attributeEntry.values[selections[attribute]];

				if (!valueEntry) {
					return false;
				}
				
				intersectingItems = {};
				
				Object.keys(valueEntry.items).forEach(function(item){
					if ( availableItems.hasOwnProperty(item)) {
						if(!checkQty || availableItems[item] > 0){
							intersectingItems[item] = availableItems[item];
						}
					}
				});

				availableItems = intersectingItems;

			});

			return availableItems;
		},
		/**
		 *  Resolves one available item based on the given selections.
		 *  @param {Object} [selections] A map of the selections where  selection is an  association of attribute to value.
		 *  @returns {String} The first resolved item, or null if no items are available for the given selections.
		 */
		resolveItem: function (selections) {
			var items, item, selection, numSelections=0;
			if (!selections) {			
				selections = this.selections;
			}
			for(selection in selections){
				++numSelections;
			}
			if(numSelections>0){
				items = this.resolveItems(selections, false);
				for (item in items) {
					if (items.hasOwnProperty(item)) {					
						return item;
					}
				}
			}
			return null;
		},
	
		checkInventory: function (item) {
	
			if (!item)
				return 0;
	
			return this.availableItems[item];
	
		},
	
		getPartNumber: function (item) {
	
			if (!item)
				return null;
	
			return this.partNumbers[item];
	
		},

		update: function (resetDefaultItems) {

			if ( DEBUG ) console.log('ProductAvailability Update');

			var self 		  = this,
				updateOptions = false,
				thisAttribute, availableItems, otherAttribute, selections, attributeEntry, value, valueEntry, item, available;
			
			Object.keys(self.attributes).forEach(function(thisAttribute){
				selections = {};
				
				Object.keys(self.attributes).forEach(function(otherAttribute){
	
					if (thisAttribute !== otherAttribute) {	

						if (self.selections[otherAttribute]) {
					
							selections[otherAttribute] = self.selections[otherAttribute];
					
						}
					
					}
				});

				availableItems = self.resolveItems(selections, true);				
				attributeEntry = self.attributes[thisAttribute];
				
				Object.keys(attributeEntry.values).forEach(function(value){
					
					valueEntry = attributeEntry.values[value];							
					available  = false;
				
					available = Object.keys(valueEntry.items).some(function(item){
						return availableItems[item];
					});

					if (resetDefaultItems === true) {
						valueEntry.defaultSelected = false;
					}
				
					valueEntry.setAvailable(available);
				});

				$.pubsub('publish', 'WCS.PRODUCT_AVAILABILITY.ALL_AVAILABLE_SET', self.parentProductFormIndex);

				updateOptions = true;
			});

		}// end of update 

	};
	return ProductAvailability;
});
